// export const STRIPE_PUBLISHABLE_KEY = "pk_test_51NHw8jKjnAk1QjV6nYywO8puBRapptfFfExYARFCCMOypQRI7gQCLh9XJVh3r3ywFCmSMqMl3ceHL382UNcIifsl00JIkZLxXr";
export const STRIPE_PUBLISHABLE_KEY = "pk_live_51NHw8jKjnAk1QjV6jZyJYUFEdrwRe6TYwildtnGvL893U5hb6HCqujdqTahFJqyIzPOlnBZoPHL41Hxy8jEIkFbY00Ntmrww5T";

export const NOT_FOUND_MODIFIER_CATEGORY_INDEX = -1
export const NOT_FOUND_MODIFIER_ITEM_INDEX = -1;
export const NOT_FOUND_EVENT_INDEX = -1;

export const NON_ENGLISH_LANGUAGE_OPTIONS = [
  { value: "zh-Hans", label: "中文 (简体)" },
  { value: "zh-Hant", label: "中文 (繁體)" },
  { value: "ja", label: "日本語" },
  { value: "ko", label: "한국어" },
  { value: "th", label: "ไทย" },
  { value: "es", label: "Español" },
  { value: "fr", label: "Français" },
  { value: "de", label: "Deutsch" },
  { value: "pt", label: "Português" },
  { value: "it", label: "Italiano" },
  { value: "vi", label: "Tiếng Việt" },
  { value: "ru", label: "Русский" },
  { value: "pl", label: "Polski" },
  { value: "hi", label: "हिन्दी" },
] as const;

// Keep this list aligned with backend ReceiptLanguageSupport.SUPPORTED_SECOND_LANGUAGE_CODES.
export const SUPPORTED_RECEIPT_SECOND_LANGUAGE_CODES = NON_ENGLISH_LANGUAGE_OPTIONS.map((o) => o.value);

export const SECOND_LANGUAGE_OPTIONS = [
  { value: "", label: "None" },
  ...NON_ENGLISH_LANGUAGE_OPTIONS,
];

export const RECEIPT_FONT_SIZE_OPTIONS = [
  { value: 1, label: "Normal" },
  { value: 2, label: "Large" },
  { value: 3, label: "X-Large" },
] as const;

export type ReceiptLanguageValue = "ENGLISH" | "SECOND" | "BOTH";

export interface ReceiptLanguageSelection {
  english: boolean;
  second: boolean;
}

/** Label for the second language (from Language tab). */
export function getSecondLanguageLabel(secondLanguage: string | null | undefined): string {
  if (!secondLanguage || secondLanguage === "") return "Second language";
  const o = NON_ENGLISH_LANGUAGE_OPTIONS.find((x) => x.value === secondLanguage);
  return o?.label ?? "Second language";
}

/** { english, second } -> "ENGLISH" | "SECOND" | "BOTH". If both false, returns "ENGLISH". */
export function toReceiptLanguageValue(s: ReceiptLanguageSelection): ReceiptLanguageValue {
  if (s.english && s.second) return "BOTH";
  if (s.second) return "SECOND";
  return "ENGLISH";
}

/** "ENGLISH" | "SECOND" | "BOTH" -> { english, second }. If !hasSecondLang, second is always false. */
export function fromReceiptLanguageValue(val: string | null | undefined, hasSecondLang: boolean): ReceiptLanguageSelection {
  if (!hasSecondLang) return { english: true, second: false };
  if (val === "BOTH") return { english: true, second: true };
  if (val === "SECOND") return { english: false, second: true };
  return { english: true, second: false };
}

